import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-chat-drawer',
  templateUrl: './chat-drawer.component.html',
  styleUrls: ['./chat-drawer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChatDrawerComponent implements AfterViewInit {


  ngAfterViewInit(): void {
  }

}
